import { createRouter, createWebHistory } from "vue-router";

//import website
import indexPage from "../src/views/index.vue";
import aboutPage from "../src/views/about.vue";
import worksPage from "../src/views/works.vue";
import workDetailsPage from "../src/views/workDetails.vue";

// import NotFound from "../src/views/error.vue";


const routes = [
    // Website routes
    { path: "/", component: indexPage, name: "index" },
    { path: "/about", component: aboutPage, name: "about" },
    { path: "/works", component: worksPage, name: "works" },
    { path: "/work/:id", component: workDetailsPage, name: "work" },
    // { path: "/404", component: NotFound},
    // { path: "/:catchAll(.*)", redirect: "/404"},
];

const router = createRouter({
    routes,
    history: createWebHistory(),
    hashbang: false,
    mode: 'html5',
    linkActiveClass: "active",
    // linkExactActiveClass: "exact-active",
    scrollBehavior() {
        // Scroll to the top of the page
        return window.scrollTo({ top: 0, behavior: 'smooth' });
    },
});

export default router;